import React from "react";

import { useTranslation } from "react-i18next";
import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Role({ role, isSelected, select, unSelect }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.role} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{t(`roles.${role.name}`, role.name)}</p>
    </div>
  );
}

export { Role };
